import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "../styles/components/ActivityGainToast.scss";

const ActivityGainToast = ({
    visible = false,
    toastId = null,
    points = "",
    unitLabel = "Activité",
    label = "",
    variant = "default",
    className = "",
    duration = 2400,
    onDone,
}) => {
    useEffect(() => {
        if (!visible) return;

        const timeoutId = setTimeout(() => {
            if (typeof onDone === "function") {
                onDone();
            }
        }, duration);

        return () => clearTimeout(timeoutId);
    }, [visible, toastId, duration, onDone]);

    if (!visible || typeof document === "undefined") return null;
    

    return createPortal(
        <div
            key={toastId}
            className={`activity-gain-toast activity-gain-toast--${variant} ${className}`.trim()}
            role="status"
            aria-live="polite"
        >
            <div className="activity-gain-toast__spark" />

            <div className="activity-gain-toast__content">
                <div className="activity-gain-toast__points-line">
                    <span className="activity-gain-toast__points">
                        {points}
                    </span>

                    <span className="activity-gain-toast__unit">
                        {unitLabel}
                    </span>
                </div>

                {label && (
                    <div className="activity-gain-toast__label">
                        {label}
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default ActivityGainToast;